import { render } from "./checkDuplicate.vue?vue&type=template&id=5bdfed20&scoped=true"
import script from "./checkDuplicate.vue?vue&type=script&lang=js"
export * from "./checkDuplicate.vue?vue&type=script&lang=js"

import "./checkDuplicate.vue?vue&type=style&index=0&id=5bdfed20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdfed20"]])

export default __exports__